export default {
      id: "icon--background-usage",
      viewBox: "0 0 1240 646",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--background-usage",
      toString: function () {
        return this.url;
      }
    }